// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        contentElementId: "",
        isCorrect: false,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.contentElementId !== undefined)
        result.contentElementId = tsValueToJsonValueFns.string(value.contentElementId);
    if (value.isCorrect !== undefined)
        result.isCorrect = tsValueToJsonValueFns.bool(value.isCorrect);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.contentElementId !== undefined)
        result.contentElementId = jsonValueToTsValueFns.string(value.contentElementId);
    if (value.isCorrect !== undefined)
        result.isCorrect = jsonValueToTsValueFns.bool(value.isCorrect);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.contentElementId !== undefined) {
        const tsValue = value.contentElementId;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.isCorrect !== undefined) {
        const tsValue = value.isCorrect;
        result.push([2, tsValueToWireValueFns.bool(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.contentElementId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.isCorrect = value;
    }
    return result;
}
